// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-layout {\n  background: #fff !important;\n}\n.ant-form-item-children {\n  display: inline-block;\n  width: 100%;\n}\n.ant-steps-item-active {\n  font-weight: 600;\n}\n.ant-menu-inline {\n  height: calc(100% - 65px);\n}\n", ""]);
// Exports
module.exports = exports;
